import { useCallback, useEffect, useState } from "react";

import client from "Libs/platform";

import type { OrganizationAddress } from "@packages/client";

export const useOrganizationAddress = (
  organizationId: string,
  options?: Partial<{ onAddressLoads: (address: OrganizationAddress) => void }>
) => {
  const [address, setAddress] = useState<OrganizationAddress>();
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    setIsLoading(true);
    const response = await client.getOrganizationAddress(organizationId);
    setAddress(response);
    if (options?.onAddressLoads) options.onAddressLoads(response);
    setIsLoading(false);
  }, [options, organizationId]);

  useEffect(() => {
    if (!address) load();
  }, [load, address]);

  return { address, isLoading, load };
};
